const CustomerManagement = () => import('@/views/customer-management/customer-management.vue')

const CustomerDetail = () => import('@/views/customer-management/CustomerDetail/CustomerDetail.vue')
export default [
  {
    path: '/CustomerManagement',
    name: 'CustomerManagement',
    component: CustomerManagement,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/CustomerDetail',
    name: 'CustomerDetail',
    component: CustomerDetail,
    meta: {
      keepAlive: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/CustomerManagement.js